import { useHits } from "react-instantsearch";
import { cn } from "../utils/cn";
import { useCachedInfiniteHits } from "../hooks/useCachedInfiniteHits";

export default function ResultsTotal({ className } : { className?: string }) {
  const { results } = useHits();
  const total = results?.nbHits || 0;

  return (
    <span className={cn("ResultsTotal", className)}>{total} products</span>
  );
}

export function ShowingNumber({ className } : { className?: string }) {
  const { items } = useCachedInfiniteHits();
  const showing = items?.length || 0;

  return (
    <span className={cn("ShowingNumber", className)}>{showing}</span>
  );
}